import React from 'react';
import { Archive as ArchiveIcon } from 'lucide-react';

const Archive: React.FC = () => {
  return (
    <div className="p-10 flex flex-col items-center justify-center h-full text-slate-400">
      <ArchiveIcon className="h-16 w-16 mb-4 opacity-20" />
      <h2 className="text-xl font-semibold text-slate-500">Archive</h2>
      <p>Archived stories will appear here.</p>
    </div>
  );
};

export default Archive;
